import { Box, Card, CircularProgress } from "@mui/material";
import { useState } from "react";
import axios from "../../../utils/axios";
import hosteo from "../../../utils/hosteo";
import { enqueueSnackbar } from "notistack";
import { HelperText } from "../HelperText";
import { Line } from "react-chartjs-2";

export default function BenefPorMes() {
  const [datos, setDatos] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const obtenerDatos = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${hosteo}/api/empadronamiento/beneficiarios/getBenefsPorMes`
      );
      setDatos(response.data);
    } catch (error) {
      enqueueSnackbar(error.message || "No tienes conexión a internet", {
        variant: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        color: "white",
      },
      title: {
        display: true,
        text: "Beneficiarios por mes",
      },
    },
  };

  const data = {
    labels: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Setiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
    datasets: [
      {
        label: "Titulares",
        data: [12, 19, 3, 5, 2, 3],
        borderColor: "rgba(255, 99, 132, 0.5)",
        color: "red",
      },
      {
        label: "Familiares",
        data: [50, 75, 4, 7, 3, 10],
        borderColor: "rgba(99, 255, 112, 0.5)",
        color: "green",
      },
    ],
  };

  return (
    <>
      <Box sx={{ mt: 2 }}>
        <HelperText
          message={
            "Grafico de como fue evolucionando la cantidad de titulares y familiares por mes"
          }
        />
      </Box>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            my: 10,
          }}
        >
          <CircularProgress size={75} />
        </Box>
      ) : (
        <Card sx={{ my: 4, p: 3 }}>
          <Line options={options} data={data} />
        </Card>
      )}
    </>
  );
}
